import axios from "axios";

import { settings } from "../Services/apiSetting";

const { checkAuthApiUrl } = settings;

export default class authCheck {
  static async authCheck() {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };

      return await axios.get(checkAuthApiUrl, config);
    } catch (err) {
      // console.error("Error during authentication check:", err.response?.data);

      throw err;
    }
  }
}
